module.exports = {
    backUrl : 'http://localhost:3400',
    mapBoxToken : 'pk.eyJ1Ijoiam9zZW5kIiwiYSI6ImNsZW9lcndmajAxbTczcm9kZDVmaHAwNmoifQ.uQpmWPQJPlSsAkNMrEnUiA',
    apiUrl : 'http://localhost:3400/api/alert'
}

